exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app-card {\n  border-radius: 2px !important;\n}\n.site-title {\n  padding: 30px;\n  font-size: 26px;\n  color: #666;\n}\n", ""]);

// exports
